import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BrandsService } from '../../../shared/services/brands.service';


@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.sass']
})
export class BrandsComponent implements OnInit {

  

  @Output() brandChanged = new EventEmitter();
  constructor(private httpClient:HttpClient,private brandsService:BrandsService) { }

  ngOnInit() {
    this.getMethod();
  }
  public brands: any[]= [];

  public getMethod(){
    this.brandsService.getBrands().subscribe((data:any)=>{
      this.brands=data;
    })
  }

  brendSelect(event) {
    this.brandChanged.emit(event.value);
  }

}
